import { AdElement, AdElementWidget, isWidgetElement, resolveWidgetUrl } from '@adflow/types';
import { DATA_SOURCE_REMOVED } from '../../store';

const CASINO_ASSET_SOURCES = ['SQUARE_IMAGE', 'LANDSCAPE_IMAGE', 'PORTRAIT_IMAGE'];

/** Whether an element's content cannot be saved. Widget links are checked by `findWidgetsWithUnusableUrl`. */
export function isInvalidElement(el: AdElement): boolean {
  if (el.type === 'TEXT') {
    return el.data.content === DATA_SOURCE_REMOVED;
  }

  if (el.type === 'CASINO_ASSET') {
    return !el.data.source || !CASINO_ASSET_SOURCES.includes(el.data.source.toString());
  }

  return false;
}

/**
 * Widget layers whose link the ad would refuse to load: empty, not https, or not on an approved
 * widget host. A template is not saved while it has any, since the served ad would show its
 * fallback image instead.
 */
export function findWidgetsWithUnusableUrl(elements: readonly AdElement[]): AdElementWidget[] {
  return elements.filter(isWidgetElement).filter((widget) => !resolveWidgetUrl(widget.data).ok);
}
